import FirmaService from 'src/modules/firma/firmaService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'FIRMA_VIEW';

const firmaViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: firmaViewActions.FIND_STARTED,
      });

      const record = await FirmaService.find(id);

      dispatch({
        type: firmaViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: firmaViewActions.FIND_ERROR,
      });

      getHistory().push('/firma');
    }
  },
};

export default firmaViewActions;
